import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center px-4 py-2 bg-teal-100 rounded-full mb-6">
              <i className="ri-building-line text-teal-600 mr-2"></i>
              <span className="text-sm font-semibold text-teal-700">About Us</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Dedicated to Excellence in <span className="text-teal-600">Every Coat &amp; Every Floor</span>
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At <strong>EB Bright Painting and Decoration Service Company</strong>, we take pride in delivering top-quality craftsmanship in painting, flooring, and home finishing. Our team brings years of experience in residential and commercial projects with a commitment to clean work, durable results, and professional service.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              We believe every home and building deserves protection, beauty, and value. Whether we are painting, installing floors, or insulating walls, we use premium materials and expert techniques for long-lasting results.
            </p>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg mb-8">
              <p className="text-xl font-semibold text-gray-900 italic">
                🎨 We don't just paint. We transform spaces.
              </p>
            </div>
            
            {/* Why Choose Us Grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Clean &amp; Professional Workers</h4>
                  <p className="text-sm text-gray-600">Respectful team that treats your space with care</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Fast, Reliable Completion</h4>
                  <p className="text-sm text-gray-600">On-time delivery without compromising quality</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Competitive &amp; Honest Pricing</h4>
                  <p className="text-sm text-gray-600">Transparent quotes with no hidden fees</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Durable Finishes That Last</h4>
                  <p className="text-sm text-gray-600">Premium materials for long-term results</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Flooring &amp; Insulation Expertise</h4>
                  <p className="text-sm text-gray-600">Complete home finishing solutions</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Customer Satisfaction Guarantee</h4>
                  <p className="text-sm text-gray-600">Your happiness is our priority</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[600px]">
                <img 
                  src="https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/aa6cd5274b9a6f5acde605d0e72dfd5f.jpeg"
                  alt="Professional painting team at work"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Floating Stats Card */}
              <div className="absolute bottom-8 left-8 right-8 bg-white rounded-2xl p-6 shadow-xl">
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="text-3xl font-bold text-teal-600 mb-1">10+</div>
                    <div className="text-sm text-gray-600">Years Experience</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-teal-600 mb-1">500+</div>
                    <div className="text-sm text-gray-600">Projects Done</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-teal-600 mb-1">100%</div>
                    <div className="text-sm text-gray-600">Satisfaction</div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal-200 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-teal-300 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
